export class Photo {
  id = -1;
  job_id = -1;
  name = "";
  file = new PhotoFile();
  download_url = "";
  source = "";
  created_by_name: string | null = null;
  created_at = ""; // date
  customer_visible = false;
  caption: string | null = null;
  scope?: "job" | "customer";

  constructor(params: Partial<Photo> = {}) {
    Object.assign(this, params);
  }
}

export class PhotoFile {
  url = "";
  thumb = new PhotoThumb();

  constructor(params: Partial<PhotoFile> = {}) {
    Object.assign(this, params);
  }
}

export class PhotoThumb {
  url = "";

  constructor(params: Partial<PhotoThumb> = {}) {
    Object.assign(this, params);
  }
}
